const landingPageAnimation = {

    init () {

        let landingPage = document.querySelector('#landing');
  
        if(landingPage){

          let logoAlu = document.querySelector('.landing-logo-alu');
          let logoAda = document.querySelector('.landing-logo-ada');
          
          logoAlu.addEventListener('mouseover', e => {
            
            logoAda.classList.add('opacity-none');
          })

          logoAlu.addEventListener('mouseout', e => {
            
            logoAda.classList.remove('opacity-none');
          })

          logoAda.addEventListener('mouseover', e => {
            
            logoAlu.classList.add('opacity-none');
          })

          logoAda.addEventListener('mouseout', e => {
            
            logoAlu.classList.remove('opacity-none');
          })
    
        }
    }
}

export default landingPageAnimation;